import {
  acceptProjectInvite,
  declineProjectInvite
} from '../../../../../pages/auth/utils/firebase/projectCollab';
import { showSuccessToast, showErrorToast } from '../../../../../utils/toastUtils';
import { markNotificationAsRead, getProjectData } from '../utils.js';

export const handleProjectInviteAccept = async (inviteId, notification, navigate) => {
  try {
    // Accept the project invite
    await acceptProjectInvite(inviteId);

    // Mark the notification as read
    await markNotificationAsRead(notification.id);

    // Get project details for navigation
    const projectData = await getProjectData(notification.projectId);

    if (projectData) {
      showSuccessToast(`Successfully joined "${projectData.title || 'the project'}"!`);

      // Navigate to the project page after a short delay
      setTimeout(() => {
        navigate(`/projects/${notification.projectId}`);
      }, 1000);
    } else {
      showSuccessToast('Successfully joined the project!');
      navigate('/projects');
    }

    return { success: true, projectData };
  } catch (error) {
    console.error('Error accepting project invite:', error);
    showErrorToast('Failed to accept project invite. Please try again.');
    return { success: false, error };
  }
};

export const handleProjectInviteDecline = async (inviteId, notification) => {
  try {
    // Decline the project invite
    await declineProjectInvite(inviteId);

    // Mark the notification as read
    await markNotificationAsRead(notification.id);

    showSuccessToast('Project invitation declined');
    return { success: true };
  } catch (error) {
    console.error('Error declining project invite:', error);
    showErrorToast('Failed to decline project invite. Please try again.');
    return { success: false, error };
  }
};

export const handleProjectLaunchedClick = async (notification, navigate) => {
  try {
    // Mark as read
    await markNotificationAsRead(notification.id);

    // Navigate to the launched project
    if (notification.projectId) {
      const projectData = await getProjectData(notification.projectId);

      if (projectData) {
        showSuccessToast(`Opening "${projectData.title || 'project'}"...`);
        navigate(`/projects/${notification.projectId}`);
      } else {
        navigate('/projects');
      }
    } else if (notification.actionUrl) {
      navigate(notification.actionUrl);
    } else {
      navigate('/projects');
    }

    return { success: true };
  } catch (error) {
    console.error('Error handling project launched notification:', error);
    return { success: false, error };
  }
};
